import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { map, switchMap } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { UserStore } from '../stores/user.store'
import { isFeatureAllowed } from '../config/feature-permission.config'

export const addonGuard: CanActivateFn = (_route: ActivatedRouteSnapshot) => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const userStore = inject(UserStore)

  return authService.user$.pipe(
    switchMap(() => {
      return userStore.getOneSelf({ useCache: true }).pipe(
        map((user) => {
          if (isFeatureAllowed('ROLEPLAY', user.enabledFeatures)) {
            return true
          } else {
            router.navigate(['/home'])
            return false
          }
        }),
      )
    }),
  )
}
